import {
  AlertIcon,
  Box,
  Button,
  Flex,
  Icon,
  Input,
  Modal,
  ModalTitle,
  PromiseModal,
  Text,
} from '@betterleap/ui';
import { convertCentsToUSD, convertUSDtoCents } from '@betterleap/shared';
import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { apiClient } from '../../../../lib/apiClient';

export interface SetPromotedJobBalanceModalProps {
  currentBalanceInCents: number;
  currentMarginInCents: number;
  organizationId: string;
}

const SetPromotedJobBalanceModal: PromiseModal<
  SetPromotedJobBalanceModalProps
> = ({
  organizationId,
  onDismiss,
  onSubmit,
  currentBalanceInCents,
  currentMarginInCents,
}) => {
  const updateOrganization = useMutation(
    ({
      balanceInCents,
      marginInCents,
    }: {
      balanceInCents: number;
      marginInCents: number;
    }) =>
      apiClient.organization.update({
        id: organizationId,
        requestBody: {
          promotedJobsBalanceInCents: balanceInCents,
          promotedJobsMarginInCents: marginInCents,
        },
      }),
    {
      onSuccess: () => {
        onSubmit();
      },
    },
  );

  const [marginInUSD, setMarginInUSD] = useState<string>(
    convertCentsToUSD(currentMarginInCents),
  );
  const [isValidBalance, setIsValidBalance] = useState<boolean>(false);
  const [balanceInUSD, setBalanceInUSD] = useState<string>(
    convertCentsToUSD(currentBalanceInCents),
  );

  const handleSubmit = () => {
    updateOrganization.mutate({
      balanceInCents: convertUSDtoCents(balanceInUSD),
      marginInCents: convertUSDtoCents(marginInUSD),
    });
  };

  useEffect(() => {
    if (balanceInUSD) {
      setIsValidBalance(true);
    } else {
      setIsValidBalance(false);
    }
  }, [balanceInUSD]);

  return (
    <Modal>
      <Flex css={{ alignItems: 'center' }} vertical>
        <Box css={{ py: 16 }}>
          <AlertIcon variant='success' name='currency-dollar' />
        </Box>
        <ModalTitle>Set Promoted Jobs Balance</ModalTitle>
        <Flex justify='center' css={{ mb: 24, gap: 10 }}>
          <Text as='p' css={{ color: '$neutral-blue-500' }}>
            Balance:
          </Text>
          <Input
            leftIcon={<Icon name={'currency-dollar'} />}
            type='number'
            value={balanceInUSD}
            onChange={setBalanceInUSD}
            css={{ width: 250 }}
          />
        </Flex>
        <Flex justify='center' css={{ mb: 24, gap: 10 }}>
          <Text as='p' css={{ color: '$neutral-blue-500' }}>
            Margin:
          </Text>
          <Input
            leftIcon={<Icon name={'currency-dollar'} />}
            type='number'
            value={marginInUSD}
            onChange={setMarginInUSD}
            css={{ width: 250 }}
          />
        </Flex>
        <Flex css={{ gap: 8, pt: 24, width: '100%' }}>
          <Button full variant='ghost' onClick={onDismiss}>
            Cancel
          </Button>
          <Button disabled={!isValidBalance} full onClick={handleSubmit}>
            Save
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default SetPromotedJobBalanceModal;
